module.exports = __webpack_public_path__ + "img/new_age_feature_02.33974099.jpg";